module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/logo-b1d136a634133f5482090d5be7d9ea20.webp";